import React from 'react';
import { PageLayout } from '@/components/PageLayout';

/**
 * Minimal shell for public routes (login, accept-invite).
 * No sidebar.
 */
export function PublicLayout({ children }: { children: React.ReactNode }) {
  return <PageLayout>{children}</PageLayout>;
}
